<div
    *ngIf="!inView()"
    class="st-topic-item-content-container"></div>
<div
    *ngIf="inView()"
    class="st-topic-item-border-left"
    st-left-border
    [data]="data()"></div>
@switch (cardViewType()) {
    @case (CardViewTypes.SMALL) {
        <ng-container *ngTemplateOutlet="smallCard" />
    }
    @case (CardViewTypes.MEDIUM) {
        <ng-container *ngTemplateOutlet="mediumCard" />
    }
    @default {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
}

<ng-template #largeCard>
    <div
        *ngIf="inView()"
        class="st-topic-item-content-container"
        [class.st-topic-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-topic-item-content-container__static">
            <div class="st-topic-item-content-container-main">
                <div class="st-topic-item-content-container-main-top-row">
                    <st-topic-type
                        class="st-topic-item-content-container-main__type"
                        showAdd
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                        [maxValuesToShow]="maxTypesToShow"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                        [value]="topicTypes()"
                        [required]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.Required"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicType)" />
                    <span class="st-topic-item-content-container-main__time-updated">{{ timeUpdatedLabel() }}</span>
                    <span class="st-topic-item-content-container-main__updated-by">{{ updatedBy() }}</span>
                </div>
                <st-text-area-overlay
                    class="st-topic-item-content-container-main__slug"
                    minRows="1"
                    minHeight="1rem"
                    maxLength="50"
                    disableNewLine
                    panelClass="st-topic-item-content-container-main__slug"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [textToHighlight]="searchString()"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateTopic($event, pstFieldNames.Title)" />
                <st-text-area-overlay
                    class="st-topic-item-content-container-main__summary"
                    minRows="3"
                    minHeight="3rem"
                    panelClass="st-topic-item-content-container-main__summary"
                    [value]="data()?.Description"
                    [disabled]="cardDisabled()"
                    [required]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.Required"
                    [textToHighlight]="searchString()"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.Description)" />
                <st-tags-autocomplete
                    [value]="data()?.Tags"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTags]"
                    [maxItemsToShow]="maxTagsToShow() | ngrxPush"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.PSTTags)" />
            </div>
            <div class="st-topic-item-content-container-meta">
                <div class="st-topic-item-content-container-meta__row">
                    <st-date-time-picker
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                        class="st-topic-item-content-container-meta__date-picker"
                        asCustomField
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                        (onTimezoneChanged)="timezoneChanged(pstFieldNames?.TargetPublicationDate, $event)"
                        (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
                    <ng-template #datePicker>
                        <st-date-picker
                            class="st-topic-item-content-container-meta__date-picker"
                            [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                            [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                            [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                            (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
                    </ng-template>
                    <st-status
                        class="st-topic-item-content-container-meta__status"
                        [value]="data()?.PSTTopicStatus"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)" />
                    <div class="st-topic-item-content-container-actions">
                        <button
                            *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp"
                            class="st-topic-item-content-container-actions__approve"
                            mat-icon-button
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTApproved]"
                            [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                            [class.st-topic-item-content-container-actions__approve--active]="data()?.PSTApproved"
                            (click)="updateTopic(!data()?.PSTApproved, pstFieldNames.PSTApproved)">
                            <mat-icon>done</mat-icon>
                        </button>
                        <button
                            class="st-topic-item-content-container-actions__fullscreen"
                            mat-icon-button
                            [matTooltip]="displayOpenActionButtonHoverTitle()"
                            [disabled]="preview()"
                            (click)="topicItemClicked.emit()">
                            <mat-icon>fullscreen</mat-icon>
                        </button>
                        @if (!isPublication()) {
                            <div *ngIf="!isPublication()">
                                <st-external-actions-overlay
                                    class="st-topic-item-content-container-actions__external"
                                    [inSidecarOpened]="inSidecarOpenedMode()"
                                    [data]="data()"
                                    [disabled]="cardDisabled() || preview()"
                                    [editable]="topicEditable()"
                                    [onObjectOpen]="topicItemClicked" />
                            </div>
                        } @else {
                            <button
                                *ngIf="isPublication()"
                                mat-icon-button
                                class="st-assignment-item-content-container-actions__delete"
                                [disabled]="isReadOnly() || cardDisabled()"
                                (click)="deletePublication($event)">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        }
                    </div>
                </div>
                <div class="st-topic-item-content-container-meta__row">
                    <st-desk
                        class="st-topic-item-content-container-assigns__desk"
                        [value]="data()?.PSTGroup"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                        (changed)="updateTopic($event, pstFieldNames.PSTDesk)" />
                    <st-staff-id-list
                        class="st-topic-item-content-container-assigns__owners"
                        [value]="data()?.PSTTopicOwner"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption"
                        (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)" />
                </div>
                <div class="st-topic-item-content-container-meta__row">
                    <st-assignment-icon-list
                        [value]="data()?.children"
                        [cardDisabled]="cardDisabled()"
                        [topicEditable]="topicEditable()"
                        [parentRecord]="data()"
                        (createAssignmentEvent)="createAssignment($event)"
                        (itemClicked)="openAssignment($event)" />
                    <st-story-icon-list
                        [value]="data()?.stories"
                        [templates]="storyTemplates()"
                        [cardDisabled]="cardDisabled()"
                        [topicEditable]="topicEditable()"
                        [parentRecord]="data()"
                        (itemClicked)="openStory($event)"
                        (createStoryEvent)="createStory($event)" />
                </div>
            </div>
        </div>
        @if (customCardItemsRet()?.length > 0) {
            <div class="st-topic-item-container-dynamic-controls">
                <ng-template
                    let-idx
                    ngFor
                    [ngForOf]="[0, 1, 2, 3]">
                    <div class="st-topic-item-container-dynamic-controls-item">
                        @if (customCardItemsRet()[idx]) {
                            <ng-container
                                [ngTemplateOutlet]="customField"
                                [ngTemplateOutletContext]="{ item: customCardItemsRet()[idx], data: data, validation: customCardItemsRet()[idx].Validation?.toUpperCase() }" />
                        }
                    </div>
                </ng-template>
            </div>
        }
    </div>

    <ng-template
        #customField
        let-item="item"
        let-data="data"
        let-validation="validation">
        <ng-container [ngSwitch]="validation">
            <ng-template [ngSwitchCase]="FieldDefValidations.LOOKUPLIST">
                <st-tags-autocomplete
                    asCustomField
                    [value]="data()?.[item.ID]"
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [label]="item.DefaultCaption"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.TEXT">
                <ng-template [ngIf]="!item.WordWrap">
                    <st-text-field
                        class="st-topic-item-container-dynamic-controls-item__text-input"
                        showLinks
                        [label]="item.DefaultCaption"
                        [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                        [textToHighlight]="searchString()"
                        [value]="data()?.[item.ID]"
                        (changed)="updateTopic($event, item.ID)" />
                </ng-template>

                <ng-template [ngIf]="item.WordWrap">
                    <st-text-area-overlay
                        class="st-topic-item-container-dynamic-controls-item__text-area"
                        minRows="1"
                        minHeight="2.5rem"
                        [textToHighlight]="searchString()"
                        [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                        [class.st-topic-item-container-dynamic-controls-item__text-area--preview]="preview()"
                        [value]="data()?.[item.ID]"
                        [placeholder]="item.DefaultCaption"
                        (changed)="updateTopic($event, item.ID)" />
                </ng-template>
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.COMBOBOX">
                <st-combo-box
                    [placeholder]="item.DefaultCaption"
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [value]="data()?.[item.ID]"
                    [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                    [label]="item.DefaultCaption"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.CHECKLIST">
                <st-check-list
                    asCustomField
                    [value]="data()?.[item.ID]"
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                    [label]="item.DefaultCaption"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.CHECKBOX">
                <st-check-box
                    [label]="item.DefaultCaption"
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [value]="data()?.[item.ID]"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.STAFFIDLIST">
                <st-staff-id-list-multiple
                    asCustomField
                    [value]="data()?.[item.ID]"
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [required]="item?.Required"
                    [label]="item.DefaultCaption"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.TREE">
                <st-tree
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [required]="enforceRequiredFieldsOnCreate && item.Required"
                    [value]="data()?.[item.ID]"
                    [label]="item.DefaultCaption"
                    [itemList]="globalTablesService.getlistItemsForTree(item.List)"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>

            <ng-template [ngSwitchCase]="FieldDefValidations.ADDRESS">
                <ng-template [ngIf]="item.ComplexPropInnerId">
                    <st-text-field
                        floating
                        [placeholder]="item.DefaultCaption"
                        [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                        [textToHighlight]="searchString()"
                        [value]="getInnerProp(item)"
                        (changed)="updateTopicAddresSubField($event, item, item.ComplexPropInnerId)" />
                </ng-template>
                <ng-template [ngIf]="!item.ComplexPropInnerId">
                    <st-address-form
                        [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                        [placeholder]="item.DefaultCaption"
                        [value]="data()?.[item.ID]"
                        (changed)="updateTopic($event, item.ID)" />
                </ng-template>
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.DATETIMERANGE">
                <st-date-time-range
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.EnforceRequiredFieldsOnCreate && item.Required"
                    [label]="item.DefaultCaption"
                    [value]="data()?.[item.ID]"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>
            <ng-template [ngSwitchCase]="FieldDefValidations.DATE">
                <st-date-picker
                    asCustomField
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [min]="getMinDate(item.ID)"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.EnforceRequiredFieldsOnCreate && item.Required"
                    [label]="item.DefaultCaption"
                    [value]="data()?.[item.ID]"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>
            <ng-template ngSwitchDefault>
                <st-date-time-picker
                    *ngIf="item.Validation.toUpperCase() === 'TIME' || item.Validation.toUpperCase() === 'MOSDATETIME'"
                    asCustomField
                    [disabled]="cardDisabled() || item.ReadOnlyValue || data()?.readOnlyCriteria[item.ID]"
                    [min]="getMinDate(item.ID)"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.EnforceRequiredFieldsOnCreate && item.Required"
                    [label]="item.DefaultCaption"
                    [value]="data()?.[item.ID]"
                    (onTimezoneChanged)="timezoneChanged(item.ID, $event)"
                    (changed)="updateTopic($event, item.ID)" />
            </ng-template>
        </ng-container>
    </ng-template>
</ng-template>

<ng-template #mediumCard>
    <div
        *ngIf="inView()"
        class="st-topic-item-content-container__medium"
        [class.st-topic-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-topic-item-content-container__medium__left-column">
            <st-topic-type
                class="st-topic-item-content-container-main__type"
                showAdd
                [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                [maxValuesToShow]="maxTypesToShow"
                [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                [value]="topicTypes()"
                [required]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.Required"
                (changed)="updateTopic($event, pstFieldNames.PSTTopicType)" />
            <div class="st-topic-item-content-container__medium__main-content">
                <st-text-area-overlay
                    class="st-topic-item-content-container-main__slug"
                    minRows="1"
                    minHeight="1rem"
                    maxLength="50"
                    maxRows="1"
                    disableNewLine
                    panelClass="st-topic-item-content-container-main__slug"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [textToHighlight]="searchString()"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateTopic($event, pstFieldNames.Title)" />
                <st-text-area-overlay
                    class="st-topic-item-content-container-main__summary"
                    minHeight="2rem"
                    panelClass="st-topic-item-content-container-main__summary"
                    maxRows="2"
                    [value]="data()?.Description"
                    [disabled]="cardDisabled()"
                    [required]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.Required"
                    [textToHighlight]="searchString()"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.Description)" />
            </div>
            <div class="st-topic-item-content-container__medium__metadata">
                <st-assignment-icon-list
                    [value]="data()?.children"
                    [cardDisabled]="cardDisabled()"
                    [topicEditable]="topicEditable()"
                    [parentRecord]="data()"
                    [maxItemsToShow]="0"
                    (createAssignmentEvent)="createAssignment($event)"
                    (itemClicked)="openAssignment($event)" />
                <st-story-icon-list
                    [value]="data()?.stories"
                    [templates]="storyTemplates()"
                    [cardDisabled]="cardDisabled()"
                    [topicEditable]="topicEditable()"
                    [parentRecord]="data()"
                    [maxItemsToShow]="0"
                    (createStoryEvent)="createStory($event)"
                    (itemClicked)="openStory($event)" />
                <st-desk
                    class="st-topic-item-content-container-assigns__desk"
                    [value]="data()?.PSTGroup"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                    [maxItemsToShow]="0"
                    (changed)="updateTopic($event, pstFieldNames.PSTDesk)" />
                <st-staff-id-list
                    class="st-topic-item-content-container-assigns__owners"
                    [value]="data()?.PSTTopicOwner"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption"
                    [maxItemsToShow]="0"
                    (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)" />
            </div>
        </div>
        <div class="st-topic-item-content-container__medium__right-column">
            <div
                class="st-topic-item-content-container-main__time-updated-by"
                [title]="timeUpdatedByLabel()">
                {{ timeUpdatedByLabel() }}
            </div>
            <st-date-time-picker
                *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                class="st-topic-item-content-container-meta__date-picker"
                asCustomField
                [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                (onTimezoneChanged)="timezoneChanged(pstFieldNames?.TargetPublicationDate, $event)"
                (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
            <ng-template #datePicker>
                <st-date-picker
                    class="st-topic-item-content-container-meta__date-picker"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                    [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                    (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
            </ng-template>

            <div class="st-topic-item-content-container__medium__right-column__status">
                <st-status
                    class="st-topic-item-content-container-meta__status"
                    [value]="data()?.PSTTopicStatus"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                    [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)"
                    (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)" />
                <button
                    *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp"
                    class="st-topic-item-content-container-actions__approve"
                    mat-icon-button
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTApproved]"
                    [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                    [class.st-topic-item-content-container-actions__approve--active]="data()?.PSTApproved"
                    (click)="updateTopic(!data()?.PSTApproved, pstFieldNames.PSTApproved)">
                    <mat-icon>done</mat-icon>
                </button>
                <button
                    class="st-topic-item-content-container-actions__fullscreen"
                    mat-icon-button
                    [matTooltip]="displayOpenActionButtonHoverTitle()"
                    [disabled]="preview()"
                    (click)="topicItemClicked.emit()">
                    <mat-icon>fullscreen</mat-icon>
                </button>
                @if (!isPublication()) {
                    <st-external-actions-overlay
                        class="st-topic-item-content-container-actions__external"
                        [inSidecarOpened]="inSidecarOpenedMode()"
                        [data]="data()"
                        [disabled]="cardDisabled() || preview()"
                        [editable]="topicEditable()"
                        [onObjectOpen]="topicItemClicked" />
                } @else {
                    <button
                        *ngIf="isPublication"
                        mat-icon-button
                        class="st-assignment-item-content-container-actions__delete"
                        [disabled]="isReadOnly() || cardDisabled()"
                        (click)="deletePublication($event)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>

<ng-template #smallCard>
    <div
        *ngIf="inView"
        class="st-topic-item-content-container__mobile">
        <div class="st-topic-item-content-container__mobile--top-row">
            <div class="st-topic-item-content-container__mobile--topic-type-container">
                @for (type of topicTypes(); track type) {
                    <div
                        class="st-topic-item-content-container__mobile--topic-type"
                        st-topic-card-type-color
                        [itemType]="type"
                        [data]="data()"></div>
                }
            </div>
            <div class="st-topic-item-content-container__mobile--status">
                {{ data()?.PSTTopicStatus || globalTablesService.FieldDefsDict[pstFieldNames.PSTTopicStatus]?.DefaultCaption }}
            </div>
        </div>
        <div class="st-topic-item-content-container__mobile--slug">
            {{ data()?.Title }}
        </div>

        <div class="st-topic-item-content-container__mobile--desk">
            <mat-icon class="st-topic-item-content-container__mobile--owner__icon"> business </mat-icon>

            <span class="st-topic-item-content-container__mobile--owner__text">{{
                getItemString(pstFieldNames.PSTDesk, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone().id, currentTimeZone().id)
            }}</span>
        </div>

        <div class="st-topic-item-content-container__mobile--owner">
            <mat-icon class="st-topic-item-content-container__mobile--owner__icon"> people </mat-icon>

            <span class="st-topic-item-content-container__mobile--owner__text">{{
                getItemString(
                    pstFieldNames.PSTTopicStoryOwner,
                    itemStringCache,
                    i18n(),
                    globalTablesService,
                    data(),
                    getInnerProp,
                    highlightPipe,
                    searchString(),
                    clientTimeZone().id,
                    currentTimeZone().id
                )
            }}</span>
        </div>

        <div class="st-topic-item-content-container__mobile--assignments">
            <mat-icon class="st-topic-item-content-container__mobile--assignments__icon"> task </mat-icon>
            <div class="st-topic-item-content-container__mobile--assignments__items">
                <st-icon
                    *ngIf="data()?.children[0]"
                    hasBorder
                    medium="true"
                    [type]="data()?.children[0]?.PSTCoverageType"
                    [data]="data()?.children[0]"
                    (click)="openAssignment(data()?.children[0])" />
                <st-icon
                    *ngIf="data()?.children[1]"
                    hasBorder
                    medium="true"
                    [type]="data()?.children[1]?.PSTCoverageType"
                    [data]="data()?.children[1]"
                    (click)="openAssignment(data()?.children[1])" />
                <st-icon
                    *ngIf="data()?.children[2]"
                    hasBorder
                    medium="true"
                    [type]="data()?.children[2]?.PSTCoverageType"
                    [data]="data()?.children[2]"
                    (click)="openAssignment(data()?.children[2])" />
                <st-icon
                    *ngIf="data()?.children[3]"
                    hasBorder
                    medium="true"
                    [type]="data()?.children[3]?.PSTCoverageType"
                    [data]="data()?.children[3]"
                    (click)="openAssignment(data()?.children[3])" />
                @if (shouldShowExtraAssignments()) {
                    <button
                        mat-icon-button
                        class="st-topic-item-content-container__mobile--assignments__items--extra">
                        +{{ extraAssignmentsCount() }}
                    </button>
                } @else {
                    <st-icon
                        *ngIf="data()?.children[4]"
                        hasBorder
                        medium="true"
                        [type]="data()?.children[4]?.PSTCoverageType"
                        [data]="data()?.children[4]"
                        (click)="openAssignment(data()?.children[4])" />
                }
            </div>
        </div>
    </div>
</ng-template>
